import React, { useState, useEffect } from 'react';
import '../../styles/ProjectTracker.css';
import { getProjects } from '../../services/api';

function ProjectTracker() {
  const [filter, setFilter] = useState('all');
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getProjects();
        setProjects(data);
      } catch (err) {
        console.error('Failed to fetch projects:', err);
      }
    };
    fetchProjects();
  }, []);

  const filteredProjects = filter === 'all' ? projects : projects.filter(p => p.status.toLowerCase() === filter);

  return (
    <div className="sp-project-tracker">
      <h2 className="sp-tracker-title">Project Tracker</h2>
      <div className="sp-tracker-filters">
        <button className="sp-filter-btn" onClick={() => setFilter('all')}>All</button>
        <button className="sp-filter-btn" onClick={() => setFilter('in progress')}>In Progress</button>
        <button className="sp-filter-btn" onClick={() => setFilter('completed')}>Completed</button>
        <button className="sp-filter-btn" onClick={() => setFilter('pending')}>Pending</button>
      </div>
      <table className="sp-tracker-table">
        <thead>
          <tr>
            <th>Service</th>
            <th>Status</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          {filteredProjects.map((project) => (
            <tr key={project.id} className="sp-tracker-row">
              <td>{project.service}</td>
              <td>{project.status}</td>
              <td>
                <div className="sp-progress-bar">
                  <div className="sp-progress-fill" style={{ width: `${project.progress}%` }}></div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ProjectTracker;